import { render, staticRenderFns } from "./RoundsReviewFilters.vue?vue&type=template&id=627729c4"
import script from "./RoundsReviewFilters.vue?vue&type=script&lang=js"
export * from "./RoundsReviewFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports